import { useCallback, useMemo } from 'react';
import { useWidget } from 'widgets/sdk';

import { formatLetterSpacing } from '../TextWidget.helpers';
import { TextWidgetData } from '../TextWidget.types';
import { computeCurveDimensions, generateTextMetricsFromPMData } from './CurvedText.helpers';

/**
 * Hook to compute the dimensions of the curved text based on prosemirror data and letter spacing
 */
export const useCurvedTextDimensions = () => {
  const { proseMirrorData, letterSpacing = 0 } = useWidget<TextWidgetData>();
  const formattedLetterSpacing = useMemo(() => formatLetterSpacing(letterSpacing), [letterSpacing]);
  const { metrics, fontSize } = useMemo(
    () => generateTextMetricsFromPMData(proseMirrorData, formattedLetterSpacing),
    [proseMirrorData, formattedLetterSpacing],
  );

  const computeDimensions = useCallback(
    (radius: number) => {
      return computeCurveDimensions(radius, fontSize, metrics);
    },
    [fontSize, metrics],
  );

  return { computeDimensions };
};
